export const UMB_ENTITY_BULK_ACTION_TRASH_KIND = 'trash';
